import { dateTime, dateTimeToDate } from 'aos-helpers/src/helpers/Time'
import { TaskFormPayload } from 'aos-services/src/services/tasks/types/payload/TaskFormPayload'
import { DateTimeRangePicker } from 'aos-ui-universal'
import React from 'react'
import { useController, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { TaskFormField } from '../TaskFormField'

export const TaskSchedulingField = () => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TaskOrTemplatePayload>()
    const task = useWatch({ control }) as TaskFormPayload
    const startTimeField = useController({ control, name: 'startTime' })
    const endTimeField = useController({ control, name: 'endTime' })

    return (
        <TaskFormField
            label={translate(
                task.recurrence !== null
                    ? 'form.scheduling-recurrence.label'
                    : 'form.scheduling.label',
                { ns: 'tasks' },
            )}
            required
            error={
                endTimeField.fieldState.error
                    ? translate('form.scheduling.error', { ns: 'tasks' })
                    : undefined
            }
        >
            <DateTimeRangePicker
                value={{
                    start: startTimeField.field.value
                        ? dateTimeToDate(startTimeField.field.value)
                        : null,
                    end: endTimeField.field.value ? dateTimeToDate(endTimeField.field.value) : null,
                }}
                onChange={range => {
                    startTimeField.field.onChange(range.start ? dateTime(range.start) : undefined)
                    endTimeField.field.onChange(range.end ? dateTime(range.end) : undefined)
                }}
            />
        </TaskFormField>
    )
}
